export const defaultPlaceholder = (formik) => {
  if (!formik.values.asignacion2) {
    return "Antes debe seleccionar el sector";
  }
  if (!formik.values.sucursaldepartamentoAsignado) {
    return `Antes debe seleccionar ${formik.values.asignacion2 === 1 ? "el departamento" : "la sucursal"}`;
  }
  if (!formik.values.motivo) {
    return "Antes debe seleccionar el motivo";
  }
  return "";
};
